import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../store';
import { onNotifyError } from '../../components/ui/toast';
import { failed } from './failedActionsSlice';

/** Mounted once, in Layout: every error toast of the session is also listed in the bell. */
export const useFailedActions = (): void => {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        onNotifyError((message, retry) => dispatch(failed(message, retry)));
        return () => onNotifyError(undefined);
    }, [dispatch]);
};
